import * as Yup from 'yup'

const schema = Yup.object().shape({
  eventId: Yup.string().required('Event is required'),
  email: Yup.string()
    .email('Email Address must be a valid email')
    .required('Email Address is required'),
})

export default schema
